module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.el, {
    tag: "component",
    attrs: {
      "label": _vm.label,
      "prop": _vm.prop,
      "required": _vm.required
    }
  }, [(_vm.noForm && _vm.showLabel) ? _c('span', [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), (!_vm.disabled || _vm.showSelectDisabled) ? _c('el-select', {
    attrs: {
      "placeholder": _vm.placeholder,
      "size": _vm.size,
      "filterable": _vm.filterable,
      "allow-create": _vm.create,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = $$v
      },
      expression: "formData"
    }
  }, [_c('template', {
    slot: "prefix"
  }, [((_vm.imageProp && _vm.form && _vm.form[_vm.imageProp]) || _vm.isImageList) ? _c('img', {
    staticClass: "prefix",
    attrs: {
      "src": _vm.isImageList ? _vm.form[_vm.labelValue] : _vm.form[_vm.imageProp]
    }
  }) : _vm._e()]), _vm._v(" "), _vm._l((_vm.localList), function(item, i) {
    return (item[_vm.valueKey]) ? _c('el-option', {
      key: item[_vm.valueKey],
      attrs: {
        "value": item
      }
    }, [((_vm.imageProp && item[_vm.imageProp]) || _vm.isImageList) ? _c('img', {
      attrs: {
        "src": _vm.isImageList ? item[_vm.valueKey] : item[_vm.imageProp]
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.isImageList) ? _c('span', [(_vm.hasIcon(i)) ? _c('i', {
      class: _vm.getIcon(i)
    }, [_vm._v(" ")]) : _vm._e(), _vm._v(_vm._s(item[_vm.labelValue]))]) : _vm._e()]) : _vm._e()
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63c371a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/selects/SelectInput.vue
// module id = 1526
// module chunks = 0